<template>
    <el-select 
        class="filterItem-value"
        v-model="filterItem.value" 
        collapse-tags
        collapse-tags-tooltip
        multiple 
        filterable>
        <el-option
            v-for="item in userList"
            :key="item.Value"
            :label="item.Text"
            :value="item.Value"
            />
  </el-select>
</template>

<script>
    import baseFilter from "../../BaseFilter"
    import { getAllUser } from "@/apis/httpHelper"

    export default {
        name:"UserFieldFilter",
        mixins:[baseFilter],
        data:function(){
            return{
                userList:[]
            }
        },
        created:function(){
            getAllUser()
            .then(x=>{
                this.userList = x.Result.Options;
            }).catch(x=>{
                console.log(x);
            });
        },
        methods:{

        }
    }
</script>